import { iframeDataBridge } from '@/iframe/iframeDataBridge';

/**
 * overlayHandler
 * @param {Ref<boolean>} menuRef - The ref controlling the menu open/close state
 * @param {Ref | string} overlaySelector - Ref to overlay element or selector string (default: '.v-overlay.v-menu')
 */
export function overlayHandler(menuRef, overlaySelector = '.v-overlay.v-menu') {
	setTimeout(() => {
		let cleanup = (e) => {
			if (overlaySelector == '.v-overlay.v-menu' && menuRef.value.menu) {
				menuRef.value.menu = false;
			} else {
				menuRef.value = false;
			}
		};

		let stopPropagation = (e) => {
			e.stopPropagation();
		};

		const iframeDocument = iframeDataBridge.getIframeWindow().document;
		let overlayEl = typeof overlaySelector === 'string' ? iframeDocument.querySelector(overlaySelector) : overlaySelector?.value || overlaySelector;
		const isActiveOverlay = overlayEl?.classList.contains('v-overlay--active');

		if (overlayEl) {
			const overlayContent = overlayEl.querySelector('.v-overlay__content');
			overlayEl.style.pointerEvents = isActiveOverlay ? 'all' : 'none';
			overlayEl.addEventListener('click', cleanup);

			if (overlayContent) {
				overlayContent.addEventListener('click', stopPropagation);
			}

			if (!isActiveOverlay) {
				overlayEl.style.display = 'none';
				overlayEl.removeEventListener('click', cleanup);
			}
		}
	}, 300);
}

export function stopPropagation(event) {
	event.stopPropagation();
}
